"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const reduxHooks_1 = require("src/hooks/reduxHooks");
const AppModal_1 = __importDefault(require("../AppModal"));
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const LoadingBtn_1 = __importDefault(require("src/components/molecules/LoadingBtn"));
const AppFormGroup_1 = __importDefault(require("src/components/molecules/AppFormGroup"));
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const thunk_1 = require("src/stores/applicationStore/projects/thunk");
const AddProjectModal = ({ show, setShow }) => {
    const dispatch = (0, reduxHooks_1.useAppDispatch)();
    const { handleSubmit, register } = (0, react_hook_form_1.useForm)();
    const [errors, setErrors] = (0, react_1.useState)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const onSubmit = (data) => {
        void dispatch((0, thunk_1.addAndSwitchProjectThunk)({
            data,
            setIsLoading,
            setErrors,
        }));
    };
    const modalBody = () => {
        return (0, jsx_runtime_1.jsx)(AppFormGroup_1.default, { label: i18n_1.default.t("Name"), error: errors === null || errors === void 0 ? void 0 : errors.name, registerName: "name", register: register });
    };
    return ((0, jsx_runtime_1.jsx)(AppModal_1.default, { setShow: setShow, modalProps: { show: show }, onSubmit: handleSubmit(onSubmit), title: i18n_1.default.t("add project"), footer: (0, jsx_runtime_1.jsx)(LoadingBtn_1.default, { successTextPosition: "left", isLoading: isLoading }), body: modalBody() }));
};
exports.default = AddProjectModal;
